// extracted by mini-css-extract-plugin
export var outer_container = "Footer-module--outer_container--3NOK6";
export var container = "Footer-module--container--E6Sm3";
export var copy = "Footer-module--copy--3ElMY";